import { connect } from 'react-redux';

import { selectors } from 'dux/user';
import ORv4Link from './ORv4Link';

function mapStateToProps(state) {
  return { isORv4User: selectors.isORv4User(state) };
}

export default connect(mapStateToProps, null)(ORv4Link);
